import { CollaborationUser } from "./CollaborationUser"
import { SelectedLines } from "./FCC"

export interface DiscussionWithTop extends Discussion {
  topPosition?: number
}

export interface CommenterUser {
  name: string
  imageSrc: string | undefined
}

export enum DiscussionState {
  Pending = "pending",
  Open = "open",
  Resolved = "resolved",
  Outdated = "outdated"
}

export interface Discussion {
  id: string
  discussion_type: string
  author_user?: CollaborationUser
  author: string
  author_context: string
  assignee: string | null
  commit_sha: string
  created_at: string
  updated_at: string
  outdated: boolean
  discussion_state: DiscussionState
  file: string
  start_line: number | null
  end_line: number | null
  start_column: number | null
  end_column: number | null
  comments: Comment[]
  side: "left" | "right"
  original_start_line: number | null
  original_end_line: number | null
  resolved_by: ResolvedBy | null
  commented_code: string
  isDiscussionWaitingForUser: boolean | null
}

export interface ResolvedBy {
  email: string
  name: string
}

export interface Comment {
  id: string
  comment_body: string
  body_content_type: "markdown" | "html"
  author: string
  author_context: string
  author_user: CollaborationUser
  created_at: string
  updated_at: string
  editable: boolean
}

export interface NewCommentBubble extends Discussion {
  type?: "new comment"
  selectedText: string | null
  selectedLines: SelectedLines
  oldContent?: string
  newContent?: string
  topPosition?: number
}
